import { render, staticRenderFns } from "./DocIndicadoresPrevineBrasil.vue?vue&type=template&id=300ba2a4&scoped=true"
import script from "./DocIndicadoresPrevineBrasil.vue?vue&type=script&lang=js"
export * from "./DocIndicadoresPrevineBrasil.vue?vue&type=script&lang=js"
import style0 from "./DocIndicadoresPrevineBrasil.vue?vue&type=style&index=0&id=300ba2a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300ba2a4",
  null
  
)

export default component.exports